var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-detail-header"},[_c('img',{attrs:{"src":_vm.image,"width":"48","height":"48","alt":"ไม่พบเลขที่ใบจองหรือทำรายการไม่สำเร็จ"}}),_c('div',[_c('div',{staticClass:"title-medium"},[_vm._v("รายการสั่งซื้อ #"+_vm._s(_vm.order))]),_c('div',[_c('div',{staticClass:"headline-m"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }